<template>
    <div class="mach-container">
        <!--规则-->
        <rule-component :config="{rules: rules}"v-if="bigImage && bigImage.length>0"></rule-component>
        <!--头部banner-->
        <div class="header-banner">
            <img :src="bigImage"
                 alt="">
            <!--跑马灯-->
            <div class="mach-marquee"
                 v-if="lampFlag && lampFlag == 1">
                <div class="mach-marquee-bg">
                    <div class="text-container">
                        <div class="text marquee-animation">
                            <span v-for="(marquees,index) in marquee"
                                  v-text="marquees"></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--tab标签-->
        <div style="height:0.89rem;">
            <div class="much-tab"
                 id="fixed-tab"v-if="bigImage && bigImage.length>0">
                <!--一级tab-->
                <div class="much-tab-item"
                     id="target">
                    <div class="item"
                         v-for="(floors,index) in cpcTab"
                         :class="{active:index == isIndex}"
                         @click.stop="changeData(index,floors)">{{floors.tab}}</div>
                </div>
    
            </div>
        </div>
    
        <!--shoplist-->
        <div class="much-shoplist">
            <div style="margin-top: -0.47rem;"
                 id="sliderContainer">
                <div class="section"
                     :class="{more:!item.feedback}"
                     v-for="(item, index) in shopList"
                     v-if="shopList && shopList.length>0">
                    <div class="advertised"
                         v-if="item.feedback">广告</div>
                    <div class="no-advertised"
                         v-if="!item.feedback">更多商户</div>
                    <div class="section-container">
                        <div class="img">
                            <a href="javascript:void(0);"
                               @click="isTurn(item.url,index)"
                               :data-midas="item.feedback">
                                <img v-lazy="item.bigImage"
                                     alt="">
                            </a>
                            <div class="tip">
                                <div class="content">
                                    <div class="left">
                                        <div class="bottom-price">
                                            <span class="pink"v-if="isShowPrice">{{item.price}}</span>
                                            <span>{{item.shopName}}</span>
                                        </div>
                                    </div>
                                    <div class="right">
                                        <div class="btn"
                                             @click.stop="showToast(item,index)"
                                             :class="{isgray:item.booked}":data-midas="item.feedback">
                                            {{item.btnText}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="loading"
             v-if="loading"></div>
        <!--toast-->
        <toast-component @isbooked="getShopData"
                         :config="{toast}"></toast-component>
        <!--樱花下落-->
        <cherry-component :config="{}"v-if="bigImage && bigImage.length>0"></cherry-component>
    </div>
</template>
<script>
import Vue from 'vue';
import $ from '@dp/zepto';
// 子组件
import RuleComponent from '../components/rule.vue';
import ToastComponent from '../components/toast.vue';
import CherryComponent from '../components/cherry.vue';
import UR from '@dp/url-rewrite';
import Midas from '@dp/m-midas-log';
import KNB from '@dp/knb';
// 链接参数
let GetQueryString = require('@lib/getQueryString');
let cityId = GetQueryString('cityid');
let isTuneup = GetQueryString('lch') || GetQueryString('utm_source') || GetQueryString('source') || "";
let oneTurnup = GetQueryString('isTuneup') || "";
let token = window.localStorage.getItem('token') || "";
// let Env = require('@lib/env');
// ajax
import {
    url,
    data,
    url_Ad,
    data_Ad
} from '../api/url';
import Hip from '@lib/hip';
// 分享
import Share from '@lib/share.js';
let shareUrl = 'https://' + location.host + '/app/app-wedding-peons/act/march_promotion/index_page.html?type=index&cityid=';
export default {
    data() {
        return {
            cityId: cityId,
            cpcTab: [{ tab: '婚纱摄影', mt_id: 20198, dp_id: 163 }, { tab: '婚宴酒店', mt_id: 20210, dp_id: 165 }, { tab: '婚庆策划', mt_id: 20201, dp_id: 167 }, { tab: '婚纱礼服', mt_id: 20199, dp_id: 162 }, { tab: '婚戒首饰', mt_id: 20202, dp_id: 191 }],
            cityName: "",
            rules: [],
            marquee: [],
            subList: [],
            dataList: [],
            adsData: [],
            shopList: [],
            isIndex: 0,
            isMap: 0,
            startX: 0,
            endX: 0,
            loading: true,
            clickLock: false,
            isShowPrice:true,
            lampFlag: "",
            bigImage: "",
            toast: {
                mobile: "",
                cityId: cityId,
                shopData: "",
                toastShow: false,
                contentShow: 0,
                index: ""
            }
        }
    },
    mounted() {
        // this.getData();
        // this.getMarqueeData();
        this.onScroll();
        this.getParameter(0);
        // this.sliderContainer();
    },
    computed: {

    },
    methods: {
        onScroll() {
            let dom = "",
                self = this,
                index = 0, domTop = "";
            let clientHeight = document.documentElement.clientHeight, headerTitleIndex;
            window.onscroll = function () {
                let scrollTop = $(this).scrollTop();
                let smallTapDom = $('.item-container');
                let headerTitle = $('.header-title');
                if (index == 0) {
                    dom = $('.much-tab');
                    domTop = dom.offset().top;
                    index++;
                }
                if (scrollTop > domTop) {
                    dom.addClass('fixe-tab')
                } else {
                    dom.removeClass('fixe-tab');
                }
            }
        },
        sliderContainer() {
            let self = this;
            $('#sliderContainer').on('touchstart', function (event) {
                // event.preventDefault();
                var _this = this;
                var preEndX = self.endX;
                if (event.targetTouches.length == 1) {
                    var touch = event.targetTouches[0];
                    //把元素放在手指所在的位置
                    self.startX = touch.pageX;
                    self.startY = touch.pageY;
                    console.log(self.startX);
                    $(_this).on('touchmove', function (event) {
                        // event.preventDefault();
                        if (event.targetTouches.length == 1) {
                            var touch = event.targetTouches[0];
                            //把元素放在手指所在的位置
                            self.endX = touch.pageX;
                            self.endY = touch.pageY;

                        }
                    })
                    $(_this).on('touchend touchcancel', function (event) {
                        // event.preventDefault();
                        // console.log(self.startX);
                        console.log(self.endX);
                        $(_this).off('touchmove');
                        $(_this).off('touchend');
                        $(_this).off('touchcancel');
                        if (self.endX - self.startX >= 55 && self.endX != preEndX && Math.abs(self.endY - self.startY) < 5) {
                            $('#target').find('.item').eq(self.isIndex + 1).click();
                        }
                        if (self.endX - self.startX <= -55 && self.endX != preEndX && Math.abs(self.endY - self.startY) < 5) {
                            $('#target').find('.item').eq(self.isIndex - 1).click();
                        }

                    })
                }
            })
        },
        getCookie(sName) {
            var aCookie = document.cookie.split("; ");
            for (var i = 0; i < aCookie.length; i++) {
                var aCrumb = aCookie[i].split("=");
                if (sName == aCrumb[0])
                    return unescape(aCrumb[1]);
            }
            return null;
        },
        getParameter(Index_) {
            let self = this;
            if (Env.isApp || Env.isWx) {
                let index = 0;
                KNB.getLocation({
                    timeout: 3000, //定位超时时间(单位秒)
                    success: function (location) {
                        data_Ad.lng = location.lng;
                        data_Ad.lat = location.lat;
                        index++;
                        all();
                    }
                })
                KNB.getUserInfo({
                    success: function (user) {
                        Env.isDPM ? data_Ad.dpid = user.uuid || "" : data_Ad.uuid = user.uuid || self.getCookie('iuuid') || "";
                        index++;
                        all();
                    }
                })
                KNB.getCity({
                    success: function (city) {
                        data_Ad.cityId = city.cityId || self.getCookie('cityid') || self.getCookie('ci');
                        index++;
                        all();
                    }
                })
                function all() {
                    if (index == 3) {
                        self.getAdData(Index_);
                    }
                    setTimeout(function(){
                        if (index != 3){
                            if (!Env.isDPM){
                                location.href ="https://g.meituan.com/app/app-wedbaby-activity-peon/act/penny_list.html";
                            }
                        }
                    },3000);
                } 
            } else {
                data_Ad.lng = "";
                data_Ad.lat = "";
                data_Ad.cityId = this.getCookie('cityid') || this.getCookie('ci') || 10;
                if (Env.isDPM) {
                    data_Ad.guid = this.getCookie('_hc.v') || "";
                } else {
                    data_Ad.uuid = this.getCookie('iuuid') || "";
                }

                self.getAdData(Index_);
            }

        },
        sendAdData(adsholist, index) {
            let self = this;
            $.ajax({
                type: 'post',
                url: url,
                data: {
                    action: 'wedPromotionCPC1704',
                    eventId: 791,
                    method: 'loadCpcList',
                    cityId: "",
                    categoryId: data.categoryIds,
                    source: (Env.isDPApp || Env.isMTApp) ? 2 : 3,
                    cpcListStr: adsholist
                },
                success: function (res) {
                    // let _resBody = res.body;
                    let _code = res.code;
                    let _msg = res.msg;

                    if (_code == 200) {
                        self.rules = _msg.page.rule;
                        self.lampFlag = _msg.page.lampFlag;
                        self.cityName = _msg.cityName;
                        self.cityId = _msg.cityId;
                        self.toast.mobile = _msg.mobile;
                        KNB.setTitle({
                            title: _msg.page.banner.activitySubject || "运营同学太懒没填写",  //标题
                            success: function () {
                            },
                            fail: function () {
                             document.title = _msg.page.banner.activitySubject || "运营同学太懒没填写";
                            }
                        });
                        self.shopList = _msg.shopList || [];
                        self.subList[index] = _msg.shopList || [];
                        self.loading = false;
                        self.bigImage = _msg.page.banner.pic;
                        if (self.lampFlag == 1) {
                            self.getMarqueeData();
                        }
                        let myShare = Share({
                            title: _msg.page.share.title || "",
                            desc: _msg.page.share.desc || "",
                            url: shareUrl + _msg.cityId,
                            image: 'https:' + _msg.page.share.pic || "",
                            content: ''
                        },function(){
                            self.lingxiClick(0,'b_2vrbd3z0');
                        });
                        //hip 打点
                        Hip(data.eventId, self.cityId);
                        //广告打点
                        setTimeout(function () {
                            Midas.init();
                            $('.no-advertised').eq(0).show();
                            $('.advertised').eq(0).show();
                        }, 500)
                        window.localStorage.setItem('token', "");
                    } else {
                        alert('网络异常,请稍后再试');
                    }
                },
                error: function () {
                    alert('系统出错！');
                }
            })
        },
        getAdData(index) {
            var self = this;
            self.loading = true;
            Vue.http.jsonp(url_Ad, {
                params: data_Ad
            }).then(function (res) {
                let _resBody = res.body;
                let _code = _resBody.code;
                let _msg = _resBody.msg;
                let _adList = _resBody.adList;
                if (_code == 200) {
                    self.adsData = JSON.stringify(_msg.ads) || "";
                    if (_adList && _adList.length > 0) {
                        self.adsData = JSON.stringify(_adList) || "";
                    }
                    self.sendAdData(self.adsData, index);
                } else if (_code == 222) {
                    self.adsData = JSON.stringify(_msg.ads) || "";
                    self.sendAdData(self.adsData, index);
                } else {
                    self.adsData = JSON.stringify(_msg.ads) || "";
                    self.sendAdData(self.adsData, index);
                }
            }, function () {
                console.log('服务繁忙,请稍后再试T_T');
            })
        },
        changeData(index, data_) {
            this.lingxiClick(index,'b_fgmed461');
            this.isIndex = index;
            if (index == 0){
               this.isShowPrice = true;
            }else{
               this.isShowPrice = false;
            }
            if (this.subList[index] && this.subList[index].length > 0) {
                this.shopList = this.subList[index];
                return;
            }
            this.shopList = [];
            this.loading = true;
            Env.isDPM ? data_Ad.categoryIds = data_.dp_id : data_Ad.categoryIds = data_.mt_id;
            data.categoryIds = data_.dp_id;
            this.getParameter(index);
        },
        lingxiClick (indexs,clickName){
               Analytics('event', {
                    nm:'mge',
                    val_bid: clickName,
                    event_type: 'click', // 可选参数
                    val_lab: { // 默认没有
                        custom: {// val_val 满足不了的信息
                            index: indexs// 这里设置自定义埋点信息
                        }
                    }
                }); 
        },
        isTurn(Url,index) {
            if (this.clickLock) {
                return;
            }
            this.lingxiClick(index,'b_4od4shdc');
            if (oneTurnup != "") {
                location.href = "https:" + Url;
                return;
            } else {
                if (Url && Url != '') {
                    this.clickLock = true;
                    setTimeout(() => {
                        this.clickLock = false;
                        if (~Url.indexOf('imeituan://') || ~Url.indexOf('dianping://')) {
                            location.href = UR.schema({ 'url': Url });
                        } else {
                            // console.log(UR.web({ 'url': Url }));
                            Url = "https:" + Url;
                            console.log(Url);
                            location.href = UR.web({ 'url': Url });
                        }
                    }, 300);

                }
            }
        },
        getMarqueeData() {
            let self = this;
            data.cityId = cityId;
            data.source = "";
            data.method = "carouselInfo";
            Vue.http.jsonp(url,
                {　　//请求参数
                    params: data
                }).then(function (res) {
                    let _resBody = res.body,
                        _code = _resBody.code,
                        _msg = _resBody.msg;

                    if (_code == 200) {
                        if (_msg.bookList) {
                            for (let i = 0; i < _msg.bookList.length; i++) {
                                self.marquee.push(_msg.bookList[i]);
                            }
                        }
                        if (_msg.prizeList) {
                            for (let j = 0; j < _msg.prizeList.length; j++) {
                                self.marquee.push(_msg.prizeList[j]);
                            }
                        }
                        console.log(self.marquee);

                    } else {
                        alert('网络异常,请稍后再试T_T');
                    }
                }, function () {
                    console.log('服务繁忙,请稍后再试T_T');
                });
        },
        showToast(shopdata, index) {
            if (shopdata.booked) {
                return;
            }
            if (!window.Env.isApp && oneTurnup == "" && isTuneup != "") {
                var urllink = 'https://' + location.host + '/app/app-wedding-peons/act/march_promotion/index_page.html?utm_source=wxpush&isTuneup=yes'
                location.href = UR.web({ 'url': urllink });

            }
            this.lingxiClick(index,'b_uhhng5pg');
            this.toast.shopData = shopdata || "";
            this.toast.toastShow = true;
            this.toast.contentShow = 1;
            this.toast.index = index;
        },
        getShopData(index) {
            this.shopList[index].booked = true;
            this.shopList[index].btnText = "已预约";
        },
        hip(name, index) {
            window._hip.push(['mv', {
                module: name,
                action: 'click',
                index: index
            }]);
        }

    },
    components: {
        RuleComponent,
        ToastComponent,
        CherryComponent
    }
}

</script>


<style lang="less" scoped>
@import "../../../less/common/share.less";
@import '../../../less/base/util.less';




/*loading样式*/

@-webkit-keyframes loading {
    from {
        -webkit-transform: rotate(0deg) translateZ(0);
    }
    to {
        -webkit-transform: rotate(360deg) translateZ(0);
    }
}

.advertised {
    position: absolute;
    width: 100%;
    margin: 0rem -0.25rem;
    color: #ccc;
    text-align: right;
    display: none;
}

// .section:first-child {
//     .advertised {
//         display: block !important;
//     }
// }
.no-advertised {
    position: absolute;
    width: 100%;
    margin: 0rem -0.25rem;
    color: #ccc;
    text-align: right;
    display: none;
}

// .more:first-of-type{
//     .no-advertised{
//        display: block !important;
//     }
// }
.loading {
    width: 25px;
    height: 25px;
    margin: 0 auto;
    -webkit-animation: loading 1s infinite linear;
    background: url(../img/loading.png) 0 0 no-repeat;
    -webkit-background-size: 25px 25px;
    background-size: 25px 25px;
}

img {
    max-width: 100%;
}

.isgray {
    background-color: #ccc !important;
}

.pink {
    color: #fe677e;
}

.fixe-tab {
    position: fixed !important;
    width: 100%;
    top: 0;
    z-index: 10 !important;
    background-color: rgba(255, 255, 255, 0.9) !important;
}

.fixe-iphone {
    position: sticky !important;
    width: 100%;
    top: 0;
    z-index: 10 !important;
    background-color: rgba(255, 255, 255, 0.9) !important;
}

.active {
    color: #fe677e;
    border-bottom: 0.02rem solid #fe677e;
}

.rectangle {
    background: url(../img/rectangle.png)no-repeat bottom;
    background-size: contain;
    display: inline-block;
    width: 0.30rem;
    height: 0.11rem;
    font-size: 0.1rem;
    text-align: center;
    padding: 0.01rem 0.05rem;
    text-indent: 0.05rem;
}

.header-banner {
    position: relative; // height: 3.5rem;
    img {
        max-width: 100%;
    }
    .mach-marquee {
        position: absolute;
        bottom: 0.09rem;
        height: 0.38rem;
        width: 100%;
        /*background-color:red;*/
        .mach-marquee-bg {
            background: url(../img/input.png) no-repeat;
            background-size: contain;
            ;
            background-position: center;
            width: 100%;
            height: 100%;
        }
        .text-container {
            position: relative;
            margin-left: 1.1rem;
            width: 2.4rem;
            height: 0.35rem;
            overflow: hidden
        }
        .text {
            position: absolute;
            width: 1500px;
            height: 100%;
            line-height: 0.38rem;
            left: 2.3rem;
            color: #5e5544;
        }
    }
    span {
        display: inline-block;
        margin: 0 0.05rem;
    }
}


















/*css跑马灯动画*/

@keyframes marqueeAnimation {
    0% {
        left: 260px;
    }
    5% {
        left: 260px;
    }
    100% {
        left: -1200px;
    }
}

@-webkit-keyframes marqueeAnimation
/* Safari 与 Chrome */

{
    0% {
        left: 260px;
    }
    5% {
        left: 260px;
    }
    100% {
        left: -1200px;
    }
}

.marquee-animation {
    animation: marqueeAnimation 15s infinite linear;
    -webkit-animation: marqueeAnimation 15s infinite linear;
    /* Safari 与 Chrome */
}


















/*tab样式*/

.much-tab {
    background-color: #fff;
    position: absolute;
    width: 100%;
    z-index: 2;
}

.much-tab-item {
    text-align: center;
    .flexbox();
    .lineBottom();
    color: #333333;
    padding: 0.15rem 0rem 0rem 0rem;
    .item {
        .boxflex(1);
        font-size: 0.15rem;
        font-weight: 600;
        padding-bottom: 0.11rem;
    }
}

.much-tab-smallitem {
    text-align: center;
    .flexbox();
    .lineBottom();
    padding: 0.1rem;
    .item-container-one {
        height: 0.24rem;
        line-height: 0.24rem;
        width: 1.1rem;
        text-align: left;
        padding-left: 0.1rem;
        font-size: 0.11rem;
        .address {
            display: inline-block;
            color: #000;
            font-weight: 800;
        }
    }
    .item {
        .boxflex(1);
        font-size: 0.1rem;
        color: #7a7a7a;
        .item-container {
            width: 0.65rem;
            height: 0.24rem;
            /*.border-1px(#666);*/
            border: 1px solid #ccc;
            border-radius: 4px;
            line-height: 0.24rem;
            position: relative;
            background: url(../img/map.png)no-repeat 13%;
            background-size: 0.11rem 0.13rem;
            margin: 0 auto;
        }
        .item_container_active {
            width: 0.65rem;
            height: 0.24rem;
            border: 1px solid #fe677e;
            border-radius: 4px;
            line-height: 0.24rem;
            position: relative;
            background: url(../img/map-active.png)no-repeat 13%;
            background-size: 0.11rem 0.13rem;
            margin: 0 auto;
        }
        span {
            display: inline-block;
            height: 0.24rem;
            line-height: 0.24rem;
        }
        .map-right {
            padding-left: 0.11rem;
            max-width: 0.4rem;
            .elli();
        }
        .map {
            position: absolute;
            top: 0.05rem;
            left: 0.04rem;
            width: 0.15rem;
            height: 0.12rem;
            background-size: contain;
        }
    }
}


















/*店铺shoplist*/

.much-shoplist {
    /*background-color: #959595;*/
    position: absolute;
    width: 100%;
    z-index: 2;
    .section-bottom {
        .flexbox();
        font-size: 0.12rem;
        border: 1px solid #ccc;
        border-top: 0px solid #ccc;
        color: #959595;
        letter-spacing: 1px;
        padding: 0.08rem 0.1rem;
        .circle-img {
            width: 0.4rem;
            height: 0.4rem;
            .radius(0.2rem);
            /*background-color: red;*/
            margin-right: 0.08rem;
            overflow: hidden;
            img {
                .radius(0.2rem);
            }
        }
        .item {
            .boxflex(1);
            padding-top: 0.06rem;
        }
        span {
            display: block;
            height: 0.15rem;
        }
    }
}

.section-container {
    padding-bottom: 0.1rem;
}

.section {
    background-color: #fff;
    margin-top: 0.08rem;
    padding: 0px 0.15rem;
    padding-bottom: .1rem;
    a {
        display: block;
        font-size: 0;
    }
    .img {
        position: relative;
        min-height: 1.85rem;
        font-size: 0;
        padding-top: 0.15rem;
        /*-webkit-animation: loading 1s infinite linear;*/
        /*background: url(../img/loading.png) 0 0 no-repeat;
                -webkit-background-size: 25px 25px;
                background-size: 25px 25px;*/
        .tip {
            position: absolute;
            padding-top: 0.1rem;
            padding-bottom: 0.115rem;
            background-color: rgba(0, 0, 0, 0.5);
            z-index: 2;
            .content {
                margin: 0px 0.15rem;
            }
            .bottom-price {
                margin-top: 0.115rem;
                font-size: 0.12rem;
            }
            width:100%;
            bottom:0px;
            color:#fff;
            .left {
                width: 60%;
                display: inline-block;
                float: left;
            }
            .right {
                display: inline-block;
                float: right;
                margin-top: 0.05rem;
                .btn {
                    width: 1.03rem;
                    height: 0.31rem;
                    background-color: #fe677e;
                    .radius(0.04rem);
                    text-align: center;
                    line-height: 0.31rem;
                    font-size: 0.14rem;
                }
            }
        }
    }
    .section-header {
        text-align: center;
        span {
            display: inline-block;
            padding: 0.125rem 0px 0.1rem 0px;
            font-size: 0.13rem;
            &::before {
                content: "—";
                color: #fe677e;
                margin-right: 0.1rem;
            }
            &::after {
                content: "—";
                color: #fe677e;
                margin-left: 0.1rem;
            }
        }
        p {
            width: 80%;
            margin: 0 10%;
            letter-spacing: 1px;
            padding-bottom: 0.1rem;
            color: #7a7a7a;
            font-size: 0.12rem;
        }
    }
}
</style>


// WEBPACK FOOTER //
// index_page.vue?9370535e